import { AfterViewInit, ChangeDetectorRef, Component, effect, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { PatientSessionService } from '../patient-session.service';
import { PatientBehaviorDataModel, PatientBehaviorModel, PatientBehaviorType, PatientTargetDataModel } from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
import { ABCDataPanelComponent } from '../abc-data-panel/abc-data-panel.component';
import { AlertService } from '../../../shared/services/alert.service';
import { Utils } from '../../../core/utils';
@Component({
  selector: 'app-box-behavior-duration',
  templateUrl: './box-behavior-duration.component.html',
  standalone: false,
})
export class BoxBehaviorDurationComponent extends BaseBoxComponent {
  @Input() text: string | undefined = '-';
  @Input() amountOfTimes: number = 0;
  @Input() isTopBox: boolean = true;
  @Input() isBottomBox: boolean = false;
  @Input() behaviorID: number = 0;
  @Input() behavior: PatientBehaviorModel | undefined = undefined;
  @Input() isPreview?: boolean;

  behaviorData: PatientBehaviorDataModel[] = [];
  abcData: PatientBehaviorDataModel[] = [];
  isStarted: boolean = false;
  timerValue: number = 0;
  private startTime: number = 0;
  times: { ID?: number, Text: string, Duration: number, RecordedDate: string, FormattedDate: string }[] = [
  ];
  behaviorType: PatientBehaviorType = PatientBehaviorType.Duration;

  timeOut: any;
  
  // Bulk add fields
  bulkStart: string = '';
  bulkEnd: string = '';
  bulkOccurrences: number | null = null;
  
  @ViewChild('abcDataPanel') abcDataPanel!: ABCDataPanelComponent;

  constructor(
    protected override cdRef: ChangeDetectorRef,
    private patientSessionService: PatientSessionService,
    private alertService: AlertService
  ) {
    super(cdRef);
    this.isBehaviorBox = true; // Mark this as a behavior box to skip repositioning
    effect(() => {
      this.patientSessionService.dataChanged();
      const behaviorData = this.patientSessionService.getBehaviorData(this.behaviorID);
      if (behaviorData && behaviorData.length > 0) {
        this.behaviorData = behaviorData.filter(t => !t.DeletedDate);
        this.times = this.behaviorData.map(t => ({ ID: t.ID??undefined, Text: t.TextValue ?? '', Duration: t.IntValue ?? 0, RecordedDate: t.RecordedDate ?? '', FormattedDate: this.formatDate(new Date(t.RecordedDate ?? '')) }));
        this.amountOfTimes = this.times.length;
        
        this.abcData = this.behaviorData.filter(data => data.Notes != null && data.Notes != undefined);
      }
      else {
        this.times = [];
        this.amountOfTimes = 0;
      }
    });

    effect(() => {
      this.patientSessionService.dataChanged();
      const targetsRunningData = this.patientSessionService.getTargetsRunningData(this.patientSessionService.getPatientSession()?.ID ?? -1,900000000+this.behaviorID);
      if (targetsRunningData) {
        this.isStarted = targetsRunningData.Data.isStarted;
        this.startTime = targetsRunningData.Data.startTime;
        this.timerValue = this.isStarted
          ? this.getCurrentTimerValue()
          : targetsRunningData.Data.timerValue;
        if (this.isStarted) {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
          }
          this.timeOut = setTimeout(() => {
            this.updateTimer();
          }, 10);
        }
      } else {
        this.isStarted = false;
        this.startTime = 0;
        this.timerValue = 0;
      }
    });
  }

  override doLongPress(): void {
    console.log('doLongPress');
    this.showExtra2();
    setTimeout(() => {
      //scroll tabs to end
      const tabs = document.querySelectorAll('.abc-tabs');
      tabs.forEach(tab => {
        tab.scrollLeft = tab.scrollWidth;
      });
    }, 100);
  }

  startTimer() {
    this.isStarted = true;
    this.startTime = Date.now();
    this.timerValue = 0;
    this.updateTimer();
    this.saveTargetRunningData();
  }

  private updateTimer(): void {
    if (this.isStarted) {
      this.timerValue = this.getCurrentTimerValue();
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      this.timeOut = setTimeout(() => {
        this.updateTimer();
      }, 1000);
    }else {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
    }
  }

  private getCurrentTimerValue(): number {
    return Math.max(0, Math.floor((Date.now() - this.startTime) / 1000));
  }

  override ngOnDestroy() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    super.ngOnDestroy();
  }


  saveTargetRunningData() {
    this.patientSessionService.setTargetsRunningData(this.patientSessionService.getPatientSession()?.ID ?? -1, 900000000+this.behaviorID, { isDurationBehavior:true, isStarted: this.isStarted, startTime: this.startTime, timerValue: this.timerValue });
  }

  stopTimer() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    if (this.timerValue > 0) {
      this.saveTime();
      this.amountOfTimes = this.times.length;
    }
    this.timerValue = 0;
    this.isStarted = false;
    this.startTime = 0;
    this.saveTargetRunningData();
  }

  saveTime() {
    const currentDate = new Date();
    const formattedDate = this.formatDate(currentDate);
    const formattedTime = this.timerString();
    let behaviorData: PatientBehaviorDataModel = {
      TextValue: formattedTime,
      IntValue: this.timerValue,
      PatientSessionID: 0,
      PatientBehaviorID: this.behaviorID,
      RecordedDate: new Date().toServerString()
    };
    this.patientSessionService.addBehaviorData(behaviorData);
    this.times.unshift({ Text: formattedTime, Duration: this.timerValue, RecordedDate: currentDate.toServerString(), FormattedDate: formattedDate });
  }

  timerString() {
    return Utils.formatTime(this.timerValue);
  }

  
  setExtraBoxes(): void {
    const dropdowns = document.querySelectorAll('.p-overlay.p-component');
    //convert Element to ElementRef
    this.extraBoxes = Array.from(dropdowns).map(dropdown => new ElementRef(dropdown));
    this.extraBoxes.push(this.extraBox);
    this.extraBoxes.push(this.extraBox2);
  }

  addFirstABCData() {
    const currentDate = new Date();
    const formattedDate = this.formatDate(currentDate);
    let behaviorData: PatientBehaviorDataModel = {
      TextValue: '0',
      IntValue: 0,
      PatientBehaviorID: this.behaviorID,
      RecordedDate: currentDate.toServerString(),
    };
    this.patientSessionService.addBehaviorData(behaviorData);
    this.addABCData({ Text: '0', Duration: 0, RecordedDate: currentDate.toServerString(), FormattedDate: formattedDate });
  }
  
  addABCData(time: { ID?: number, Text: string, Duration: number, RecordedDate: string, FormattedDate: string }) {
    this.closeExtra2();
    this.abcDataPanel.initializeABCData(time.RecordedDate);
    this.abcDataPanel.setEditingABCData(time.RecordedDate);
    this.showExtra();
    setTimeout(() => {
      //scroll tabs to end
      const tabs = document.querySelectorAll('.abc-tabs');
      tabs.forEach(tab => {
        tab.scrollLeft = tab.scrollWidth;
      });
    }, 100);
  }

  hasABCData(time: { ID?: number, Text: string, Duration: number, RecordedDate: string, FormattedDate: string }): boolean {
    return !!this.abcData.find(data => data.RecordedDate === time.RecordedDate);
  }

  seeABCData(time: { ID?: number, Text: string, Duration: number, RecordedDate: string, FormattedDate: string }) {
    this.closeExtra2();
    this.abcDataPanel.setEditingABCData(time.RecordedDate);
    this.showExtra();
  }

  deleteData(data: any) {
    //confirm the deletion
    const confirmed = this.alertService.confirm('Are you sure you want to delete this data?', 'Delete Data');
    confirmed.subscribe(result => {
      if (result) {
        let behaviorDataToSave: PatientBehaviorDataModel | undefined = this.behaviorData.find(t =>
          t.RecordedDate === data.RecordedDate
        );

        if (behaviorDataToSave) {
          console.log('Updating existing anecdotal data:', behaviorDataToSave);
          behaviorDataToSave.DeletedDate = new Date().toServerString();

          this.patientSessionService.saveBehaviorData(behaviorDataToSave);
        }
      }
    });
  }

}
